<button
  class="ask-an-analyst-button btn"
  [ngClass]="primaryButton ? 'mc-btn-primary' : 'mc-btn-secondary'"
  [disabled]="disabled"
  (click)="showModal()"
  data-hook="ask-the-analyst-button"
  [ngbTooltip]="tooltipText"
  [placement]="tooltipPlacement"
  [disableTooltip]="tooltipDisabled"
  [attr.data-testid]="'btn-' + label | slugify"
>
  @if (showButtonLabelText) {
    <span class="analyst-text" data-hook="ask-the-analyst-button-text">
      {{ label }}
    </span>
  }
</button>
